const data = require("./quran.json")

export const boardDefault = [
	["","","","",""],
	["","","","",""],
	["","","","",""],
	["","","","",""],
	["","","","",""],
	["","","","",""]
];

function normalize_text(text) {

	  //normalize Arabic	
	  text = text.replace(/(ٱ|آ)/g, 'ا');
	  text = text.replace(/(ئ|ؤ|إ|أ)/g, 'ء')
	
	  //remove special characters
	  text = text.replace(/([^\u0621-\u063A\u0641-\u064A\u0660-\u0669a-zA-Z 0-9])/g, '');

	  

	  return text;
	}

function returnString() {
	const ayahs = data.map(function(value) {
	let ayah = "";

	//I am going to return a string. The string will comprise
	//the entire chapter of the Quran. Don't forget to leave a space between each word.
	//

	for (let i = 1; i <= value.total_verses; i++) {
		
		let obj = value.verses.find(o => o.id === i)
		ayah = ayah + normalize_text(obj.text) + ' '

	}
	//now we have to split the string into an array of words equal to 5 characters long
	const myArray = ayah.split(" ")
	const modifiedArr = myArray.filter(word => word.length === 5)
	const newAyah = modifiedArr.join(' ');


	// return value.transliteration
	return newAyah
})
	return ayahs
}

function returnArr() {
	const strOfQuran = returnString().join(" ")
	const arrOfQuran = strOfQuran.split(" ");
	return arrOfQuran
}

export function generateWordSet() {
	const wordBank = new Set(returnArr())
	return wordBank
}

export function randWord() {
	const wordArr = [...generateWordSet()]
	const randomWord = wordArr[Math.floor(Math.random() * wordArr.length)];
	return randomWord
}


